import { AfterViewChecked, Component, ElementRef, OnInit, ViewChild, input, ChangeDetectionStrategy } from '@angular/core';
import { GenderScaleTendency } from '../../enums/gender-scale-orientation.enum';

@Component({
  selector: 'customer-gender-scale',
  templateUrl: './gender-scale.component.html',
  styleUrls: ['./gender-scale.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class GenderScaleComponent implements OnInit, AfterViewChecked {
  @ViewChild('femaleIndicator') femaleIndicator: ElementRef;
  @ViewChild('maleIndicator') maleIndicator: ElementRef;
  @ViewChild('indicatorWrapper') indicatorWrapper: ElementRef;

  /** defines the distribution of one gender. male distribution >= 0, female distribution <= 0; values between -1 and 1 */
  readonly distribution = input.required<number>();
  readonly showInformation = input(false);
  readonly moreMaleText = input('merit-budget.hr-research.gender-pay-scale.more');
  readonly moreFemaleText = input('merit-budget.hr-research.gender-pay-scale.less');
  readonly headline = input('merit-budget.hr-research.gender-pay-scale.headline');
  readonly tooltipText = input('merit-budget.hr-research.gender-pay-gap.text');

  public tendency: GenderScaleTendency;
  public percentage: number;

  public get hasNoGap(): boolean {
    return this.tendency === GenderScaleTendency.None;
  }

  public get hasFemaleGap(): boolean {
    return this.tendency === GenderScaleTendency.Female;
  }

  public get hasMaleGap(): boolean {
    return this.tendency === GenderScaleTendency.Male;
  }

  public ngOnInit(): void {
    if (this.distribution() > 0) {
      this.tendency = GenderScaleTendency.Male;
      this.percentage = this.distribution() * 100;
    } else if (this.distribution() < 0) {
      this.tendency = GenderScaleTendency.Female;
      this.percentage = this.distribution() * 100 * -1;
    } else {
      this.tendency = GenderScaleTendency.None;
      this.percentage = 0;
    }
  }

  public ngAfterViewChecked(): void {
    const fullIndicatorWidth = this.indicatorWrapper.nativeElement.getBoundingClientRect().width;
    if (fullIndicatorWidth > 0) {
      if (this.hasFemaleGap) {
        this.femaleIndicator.nativeElement.style.width = `${this.percentage * 3}%`;
      } else if (this.hasMaleGap) {
        this.maleIndicator.nativeElement.style.width = `${this.percentage * 3}%`;
      } else {
        this.maleIndicator.nativeElement.style.width = 0;
      }
    }
  }
}
